import React from "react";
import styled from "styled-components";

export default styled.h3`
    font-size: 24px;
    font-family: "Proxima-Nova";
    color: #515151;
    font-weight: 700;
    margin: 0;
    padding-bottom: 10px;
`;  